import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron-down\">\n  <path fill=\"currentColor\" width=\"20\" height=\"20\" fill-rule=\"evenodd\" d=\"M12 18.4143 2.04295 8.45705l1.4141-1.4141L12 15.5857l8.54295-8.54275 1.4141 1.4141z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol